import React from "react";

import { ReactComponent as CloseButtonSvg } from "../../assets/ExitDelete.svg";

import * as S from "./styles";

interface IFilterModalProps {
    onClose: () => void;
}

const HeaderFilter: React.FC<IFilterModalProps> = ({ onClose, children }) => {
    return (
        <S.TopTitleFilter>
            <span > {children || 'Filtrar'} </span>
            <button onClick={onClose}>
                <CloseButtonSvg />
            </button>
        </S.TopTitleFilter>
    )
};

export default HeaderFilter;
